import React from 'react'
import PropTypes from 'prop-types'
import { Box, Icon, Dropdown, Text, Button as FilterButton } from '@deseretbook/react-ui'
import { Button } from '../../../dbWebUI'
import { VIEW_OPTIONS, SORT_OPTIONS, FILTER_OPTIONS } from '../constants'
import useDropdown from '../../../hooks/useDropdown'
import ViewOptions from './ViewOptions'

import './ViewFilters.css'

/**
 * A `ViewFilters` component with added filter and sort options.
 *
 * @todo Write tests for this
 * @todo Add story for this
 * @returns {function} Component
 */
const ViewFilters = ({
  currentView,
  toggleView,
  currentSort,
  updateSort,
  currentFilters,
  updateFilters,
}) => {
  const dropdown = useDropdown()
  const filterDropdown = useDropdown()

  /**
   * Updates the current sort method.
   *
   * @param {string} value - New sort method
   */
  const handleSortChange = (value) => {
    updateSort(value)
  }

  const handleFilterChange = (value) => {
    // Add or remove the filter from the list
    if (currentFilters.includes(value)) {
      updateFilters(currentFilters.filter((filter) => filter !== value))
    } else {
      updateFilters([...currentFilters, value])
    }
  }

  return (
    <>
      <div className="ViewFiltersContainer" style={{ display: 'flex', alignItems: 'center' }}>
        <FilterButton
          {...dropdown.triggerProps}
          className="view-filters-button view-filters-button-sort"
        >
          <Box as="span" alignItems="center">
            <Icon name="sort" color="#000000A6" width="2rem" height="2rem" />
            <Text className="view-filters-text" as="span">
              {currentSort}
            </Text>
          </Box>
        </FilterButton>
        <FilterButton
          {...filterDropdown.triggerProps}
          className="view-filters-button view-filters-button-filter"
        >
          <Box as="span" alignItems="center">
            <Icon name="filter" color="#000000A6" width="2rem" height="2rem" />
            <Text className="view-filters-text" as="span">
              {currentFilters.length ? `${currentFilters.length} Filters` : 'Filter'}
            </Text>
          </Box>
        </FilterButton>
        <ViewOptions currentView={currentView} toggleView={toggleView} />
      </div>
      <Dropdown {...dropdown.dropdownProps} id="MediaCardDropdown">
        <Box as="span" alignItems="start" isColumn>
          {Object.values(SORT_OPTIONS).map((option) => (
            <Button
              id="sort-button"
              onClick={() => {
                handleSortChange(option)
                dropdown.close()
              }}
            >
              <Box alignItems="center">
                <Icon
                  name={`radio${currentSort === option ? 'On' : 'Off'}`}
                  color={currentSort === option ? 'primary' : 'input'}
                  style={{ marginRight: '0.5rem' }}
                />
                <Text style={{ fontWeight: 500 }}>{option}</Text>
              </Box>
            </Button>
          ))}
        </Box>
      </Dropdown>
      <Dropdown {...filterDropdown.dropdownProps} id="MediaCardDropdown">
        <Box as="span" alignItems="start" isColumn>
          {Object.values(FILTER_OPTIONS).map((option, index) => (
            <div
              style={{
                borderBottom: !index ? '1px solid #dbdbdb' : 'none',
                padding: !index ? '0.5rem 0' : '0',
              }}
            >
              <Button
                id="sort-button"
                onClick={() => {
                  handleFilterChange(option)
                }}
              >
                <Box alignItems="center">
                  <Icon
                    name={`checkbox${currentFilters.includes(option) ? 'On' : 'Off'}`}
                    color={currentFilters.includes(option) ? 'primary' : 'input'}
                    style={{ marginRight: '0.5rem' }}
                  />
                  <Text style={{ fontWeight: 500 }}>{option}</Text>
                </Box>
              </Button>
            </div>
          ))}
        </Box>
      </Dropdown>
    </>
  )
}

export default ViewFilters

ViewFilters.defaultProps = {
  currentView: VIEW_OPTIONS.grid,
  toggleView: () => {},
  currentSort: SORT_OPTIONS.recentlyAdded,
  updateSort: () => {},
}

ViewFilters.propTypes = {
  /** The current media view option */
  currentView: PropTypes.string,
  /** Updates the current view method (list, grid) */
  toggleView: PropTypes.func,
  /** The current media sorting option */
  currentSort: PropTypes.string,
  /** Updates the current sorting option */
  updateSort: PropTypes.func,
}
